import React from 'react';
import { differenceInDays } from 'date-fns';
import { locale, getExpirationMessage } from '@trqk/utils';
import cx from 'classnames';
import _capitalize from 'lodash/capitalize';

import { getPlanDisplayName } from '.';

/**
 * Given a current payment plan, return some bits of UI for rendering
 * @param planSettings - see {@link ChargebeePlanSettings}
 * @returns see {@link PaymentPlanLocale}
 */
export const getLocaleForCurrentPlan = (
    planSettings: ChargebeePlanSettings | null,
    subscriptionSettings: ChargebeeSubscriptionSettings | null,
): PaymentPlanLocale => {
    const planId =
        planSettings !== null
            ? planSettings.id
            : subscriptionSettings?.subscription_plan_type ?? null;

    const title = getPlanDisplayName(planSettings?.display_name, planId);

    const expirationDate =
        subscriptionSettings?.subscription_expiration_date ?? null;

    const expiresInDays =
        expirationDate !== null
            ? differenceInDays(new Date(expirationDate), new Date())
            : null;

    let expirationMessage = '';
    let expirationSubTitle = <></>;

    if (expirationDate !== null) {
        expirationMessage = _capitalize(
            getExpirationMessage({
                expirationDate: new Date(expirationDate),
                verbPast: locale.enUS.EXPIRATION_DATE.EXPIRED,
                verbPresent: locale.enUS.EXPIRATION_DATE.RENEWS,
            }),
        );
    }

    if (expiresInDays !== null) {
        expirationSubTitle = (
            <span
                className={cx('font-semibold', {
                    'text-quinary-500':
                        expiresInDays < 11 && expiresInDays >= 0,
                    'text-highlight-magenta': expiresInDays < 0,
                    'text-secondary-500': expiresInDays > 10,
                })}
            >
                {expirationMessage}
            </span>
        );
    }

    if (planId !== 'CHARGEBEE_PLAN_TRIAL') {
        return {
            title,
            subTitle: expirationSubTitle,
        };
    }

    if (planId === 'CHARGEBEE_PLAN_TRIAL') {
        return {
            title,
            subTitle: expirationSubTitle,
        };
    }

    // Current free trial
    return {
        title,
        subTitle: null,
    };
};
